import type { IconType } from '@/lib/icons'
import { Ban, CircleCheck, Clock3 } from '@/lib/icons'
import type { PayoutStatus, PayoutType } from '@ayub/shared'
import { PayoutStatus as PayoutStatusEnum, PayoutType as PayoutTypeEnum } from '@ayub/shared'

/**
 * `PayoutStatus`/`PayoutType` uchun ikonka va rang — `docs/04-ui-ux.md`: "Rang hech qachon
 * yagona signal emas", shuning uchun HAR DOIM matn/ikonka bilan birga ishlatiladi. Shared
 * paket bularga alohida label bermaydi (faqat `VIDEO_STAGE_LABELS`/`BLOGGER_STAGE_LABELS` bor),
 * shuning uchun `stageMeta.ts` naqshiga mos ravishda shu yerda, WebApp'ga xos.
 */
interface StatusMeta {
  icon: IconType
  textClass: string
  subtleClass: string
}

export const PAYOUT_STATUS_META: Record<PayoutStatus, StatusMeta> = {
  [PayoutStatusEnum.REQUESTED]: {
    icon: Clock3,
    textClass: 'text-urgency-today-text',
    subtleClass: 'bg-urgency-today/10',
  },
  [PayoutStatusEnum.PAID]: {
    icon: CircleCheck,
    textClass: 'text-urgency-done-text',
    subtleClass: 'bg-urgency-done/10',
  },
  [PayoutStatusEnum.CANCELLED]: {
    icon: Ban,
    textClass: 'text-app-hint',
    subtleClass: 'bg-app-hint/10',
  },
}

export const PAYOUT_STATUS_LABELS: Record<PayoutStatus, string> = {
  REQUESTED: "So'ralgan",
  PAID: "To'landi",
  CANCELLED: 'Bekor qilindi',
}

/** `PayoutListItem.type` — qatorda kichik izoh sifatida (masalan "Admin qo'lda"). */
export const PAYOUT_TYPE_LABELS: Record<PayoutType, string> = {
  [PayoutTypeEnum.ON_REQUEST]: "Bloger so'rovi",
  [PayoutTypeEnum.SCHEDULED]: 'Rejali (5-sana)',
  [PayoutTypeEnum.MANUAL]: "Admin qo'lda",
}
